export const PHONE_TEL_INPUT = `phone-tel-input`;

export const BROWSER_NAMES = {
  SAFARI: 'Safari',
};

export const GOOGLE_APPLE_PAY_DISPLAY_STATUSES = {
  close: 0,
  open: 1,
};

export const CARD_DISPLAY_STATUSES = {
  close: 0,
  open: 1,
  openManually: 2,
};

export const KSA_ZAIN_OPERATOR = 'KSA-ZAIN';
export const KSA_MOBILY_OPERATOR = 'KSA-MOBILY';
export const KSA_STC_OPERATOR = 'KSA-STC';
export const KW_STC_OPERATOR = 'KUWAIT-STC';
export const IQ_ASICCELL_OPERATOR = 'IRAQ-ASIACELL';
export const IQ_ZAIN_OPERATOR = 'IRAQ-ZAIN';

export const foxPushDisplayId = 'foxpush_display_1000341';

export const routesThatShowsAd = { gam: foxPushDisplayId };

export const CLOUDFRONT_LANDING_PAGE_ROOT_URL = 'https://d2rwz7a7lb9mw2.cloudfront.net/landingpage';
export const CLOUDFRONT_LOGOS_ROOT_URL = 'https://d2rwz7a7lb9mw2.cloudfront.net/logos';
export const CLOUDFRONT_GOVIP_ROOT_URL = 'https://d2rwz7a7lb9mw2.cloudfront.net/govip';

export const APP_THEMES = {
  WHITE: 'white',
  BLACK: 'black',
  BLUE: 'blue',
};

export const WHITE_THEME_CLASS_NAME = 'white-version';
export const BLUE_THEME_CLASS_NAME = 'blue-version';

export const withoutAnalytics = true;

export const SERVER_STATUS_CODE_RESPONSES = {
  USER_ALREADY_SUBSCRIBED: 10132,
  ADDITIONAL_ADCTION_REQUIRED: 10102,
};

export const LANDING_PAGE_VIEWS = {
  MAIN: 'main',
  PHONE_NUMBER: 'phoneNumber',
};

export const VARIATION_KEYS = {
  v3: 'v3',
  v4: 'v4',
  v5: 'v5',
};

export const DVPASS_DCB_PROTECT_CHALLENGE_NAME = 'dvpassDCBProtectChallenge';

export const LAYOUT_TYPES = {
  TV: 'tv',
  WEB: 'web',
};

export const UTM_ID_QUERY_KEY = 'utm_id';
export const initiative_utm_id = 'initiative';

export const USER_ALREADY_SUBSCRIBED_UNIFIED_RESPONSE_CODE = '10132';

export const STC_APPROVED_SECURE_SOURCE = 'api-web-KSA_hosteddcb_STC_approval';

export const VATIATION_TEMPLATE_NAMES = {
  template1: 'template1',
  template2: 'template2',
  template3: 'template3',
};
